import { createFileRoute } from "@tanstack/react-router";
import { storage } from "../lib/storage";

export const Route = createFileRoute("/auth/telegram/callback")({
  component: TelegramOidcCallback,
});

/**
 * Landing point for the backend's Telegram OIDC callback. The backend has
 * already verified the login and hands over the Sanctum token plus the user,
 * so this only mirrors them into storage (same keys as telegramAuth) and
 * bounces to the app — nothing is rendered.
 */
function TelegramOidcCallback() {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const user = params.get("user");
    const failure = params.get("error");

    if (token && !failure) {
      storage.setItem("auth_token", token);

      if (user) {
        try {
          storage.setItem("auth_user", atob(user));
        } catch {
          /* ignore a malformed payload; the app can load the profile itself */
        }
      }

      window.dispatchEvent(new Event("lotin:auth"));
      window.location.replace("/");
    } else {
      window.location.replace(`/?auth_error=${failure ?? "missing_token"}`);
    }
  }

  return null;
}
